// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"EmptyMessage_emptyMessage__1-_ZU"};